import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
  Grid,
  Button,
} from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import { Error } from "../../../common/Error";
import React from "react";
import { InformationRequestAction } from "../../../../domain/InformationRequestAction";
import { useDispatch } from "react-redux";
import { postMessageAction } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: 15,
  },
}));

export const RespondActionDialog: React.FC<{
  onClose: () => void;
  action: InformationRequestAction;
  organisationRecipientId: string;
  itemId: string;
}> = ({ onClose, action, organisationRecipientId, itemId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { handleSubmit, control, errors } = useForm({
    defaultValues: {
      responseMessage: null,
    },
  });

  const handleSubmitResponse = (data: { responseMessage: string }) => {
    dispatch(
      postMessageAction(
        action.informationRequestId,
        organisationRecipientId,
        itemId,
        action.id,
        data.responseMessage
      )
    );
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">Respond to Message</DialogTitle>
      <Divider />
      <DialogContent>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid item xs={12}>
                    <MarkdownEditor value={action.message} readOnly />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="responseMessage"
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <>
                      <label>Your response:</label>
                      <MarkdownEditor onChange={onChange} value={value} />
                    </>
                  )}
                />
              </Grid>
              {errors.responseMessage && <Error>This field is required</Error>}
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-action-dialog"
        >
          Close
        </Button>
        <Button
          onClick={handleSubmit(handleSubmitResponse)}
          color="primary"
          data-test="confirm-create-action-button"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
